export default {"src":"/_next/static/media/vietnam.3dc879d7.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};